import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

axios.defaults.withCredentials = true;

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState({
    loading: true,
    authed: false,
  });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get("/api/auth/me");
        setState({ loading: false, authed: !!data?.authed });
      } catch {
        setState({ loading: false, authed: false });
      }
    })();
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen grid place-items-center text-[#6B7280]">
        Проверка авторизации…
      </div>
    );
  }

  if (!state.authed) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
